export default "__VITE_ASSET__C6rkcQH$__"